import { useCallback } from 'react';

import { observer } from 'mobx-react';

import { useStores } from '../../../../stores/useStores';
import type { ChallengeWidgetDataType, WidgetSizeType } from '../../types';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import { ChallengeSmallWidget } from './ChallengeSmallWidget/ChallengeSmallWidget';
import { ChallengeTimer } from './ChallengeTimer/ChallengeTimer';
import { ChallengeWideWidget } from './ChallengeWideWidget/ChallengeWideWidget';

interface ChallengeWidgetProps {
  sizeType: WidgetSizeType;
  data: ChallengeWidgetDataType;
}

function ChallengeWidgetComponent(props: ChallengeWidgetProps) {
  const { sizeType } = props;

  const { challengesStore } = useStores();
  const { activeMissionProgress, activeMissionCoinType } = challengesStore;

  const progressPercentage = activeMissionProgress
    ? Math.min((activeMissionProgress.current / activeMissionProgress.target) * 100, 100)
    : 0;

  const timerIncluded = !!activeMissionProgress?.expiresAt;

  const timer = timerIncluded ? <ChallengeTimer extended={sizeType === 'wide'} /> : undefined;

  const onClick = useCallback(() => {
    void challengesStore.startChallengesDialog(activeMissionCoinType);
  }, [activeMissionCoinType, challengesStore]);

  return (
    <WidgetWrapper smallWidgetExtended sizeType={sizeType} onClick={onClick}>
      {sizeType === 'small' ? (
        <ChallengeSmallWidget
          current={activeMissionProgress?.current ?? 0}
          progressPercentage={progressPercentage}
          target={activeMissionProgress?.target ?? 0}
          timer={timer}
          timerIncluded={timerIncluded}
        />
      ) : (
        <ChallengeWideWidget
          current={activeMissionProgress?.current ?? 0}
          progressPercentage={progressPercentage}
          target={activeMissionProgress?.target ?? 0}
          timer={timer}
        />
      )}
    </WidgetWrapper>
  );
}

export const ChallengeWidget = observer(ChallengeWidgetComponent);
